/* Instructions
Add feature to bookie you want to remove the feature from

i.e
betmakers: {
  raceOverview: false
}

Create a new feature:
 - v-if="typeof featureToggle[bookie].raceOverview === 'undefined'"
 - See Form.vue for an example

list of features:
  - raceName
  - raceOverview
  - raceField
  - runnersList
  - speedMap
  - pastStarts
  - runnerComments
*/
export const featureToggle = {
  topsport: {
    raceOverview: false,
    runnerComments: false,
    speedMap: false
  },
  tomwaterhouse: {
  },
  neds: {
    runnerComments: false,
    speedMap: false
  },
  bbet: {
    runnerComments: false,
    speedMap: false
  },
  realbookie: {
  },
  betdeluxe: {
  },
  daviddwyer: {
    runnerComments: false,
    speedMap: false
  },
  betmakers: {
    runnerComments: false,
    speedMap: false
  },
  robwaterhouse: {
  },
  do: {
  },
  picnicbet: {
  },
  uat: {},
  crossbet: {
  },
  texbet: {
    runnerComments: false
  },
  zbet: {
    runnerComments: false
  },
  mailbag: {
    runnerComments: false,
    speedMap: false
  },
  nztab: {
    runnerComments: false,
    speedMap: false
  },
  dimers: {
    runnerComments: false,
    speedMap: false
  },
  pronet: {
    runnerComments: false,
    speedMap: false
  },
  sportsbetting: {},
  wishbet: {
  },
  caymanasbet: {},
  betnation: {},
  getsetbet: {},
  punt123: {},
  marantelli: {},
  okebet: {},
  betgold: {},
  monmouth: {},
  monmouthtech: {},
  bossbet: {},
  readybet: {},
  swiftbet: {},
  baggybet: {},
  upcoz: {},
  mintbet: {},
  betr: {},
  sportchamps: {},
  foxcatcher: {},
  eskanderbet: {},
  diamondbet: {},
  bitwinning: {},
  thunderbet: {},
  betestate: {},
  playwestbet: {},
  chasebet: {},
  premiumbet: {},
  bet66: {},
  betlocal: {}
}
